
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 25C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0 0 5.596 0 12.5 5.596 25 12.5 25z","fill":"#000"}}),_c('path',{attrs:{"d":"M12.5 22.166c5.338 0 9.666-4.328 9.666-9.666S17.838 2.834 12.5 2.834 2.834 7.162 2.834 12.5a9.666 9.666 0 009.666 9.666z","fill":"#000","stroke":"#fff","stroke-width":".813","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.5 2.834v2.655M12.5 19.516v2.655","stroke":"#fff","stroke-width":".813","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.49 12.505H2.833","stroke":"#fff","stroke-width":".813","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M22.171 12.505h-2.655","stroke":"#fff","stroke-width":".813","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.326 11.229l5.718-3.12-3.089 5.75-6 3.364 3.37-5.994z","fill":"#000","stroke":"#fff","stroke-width":".927","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.326 11.229l2.645 2.614","stroke":"#fff","stroke-width":".927","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    